import styled, { css } from "styled-components";
import { MenuItem, Select } from "@mui/material";
import Button from "@mui/material/Button";

import { breakpoints } from "@/styles/breakpoints";

export const StyledDetailsPage = styled.div`
    margin-top: 24px;
    display: flex;
    @media ${breakpoints.xs} {
        flex-direction: column;
    }
    .MuiBox-root {
        padding: 0 8px;
    }

    .tabPanel .MuiBox-root {
        display: flex;
        flex-wrap: wrap;
    }
    span.wrapper {
        font-size: var(--size-14);
    }
`;

export const StyledLeftSide = styled.div`
    flex: 1;
    max-width: 320px;
    padding-right: 20px;
    @media ${breakpoints.xs} {
        max-width: none;
        padding-right: 0;
    }
`;

export const StyledActionList = styled.div`
    padding: 6px 8px 16px 8px;
    margin-bottom: 15px;
    background-color: var(--color-secondary-light);
    border-radius: var(--radius-5);
`;

export const StyledActionItem = styled(Button)<{ $disabled: boolean }>`
    width: 100%;
    padding: 5px 20px;
    margin-top: 10px;
    font-size: var(--size-16);
    line-height: 27px;
    color: var(--color-primary);
    text-transform: none;
    background: var(--color-white);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    justify-content: left;
    text-align: left;
    &:hover {
        background-color: var(--color-selected);
    }

    ${(props) =>
        props.$disabled &&
        css`
            position: relative;
            pointer-events: none;
            opacity: 0.5;
            &::before {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                pointer-events: auto;
                content: "";
                cursor: default;
            }
        `}
`;

export const StyledPanelWrapper = styled.div`
    position: relative;
    padding: 15px 8px;
    margin-bottom: 50px;
    background-color: var(--color-secondary-light);
    border-radius: 0 var(--radius-10) var(--radius-10) var(--radius-10);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    @media ${breakpoints.xs} {
        min-height: 50px;

        .tabPanel .MuiBox-root {
            display: block;
        }
    }

    .pagination {
        margin-bottom: 15px;
        width: calc(100% - 30px);
        border-top: 1px solid var(--color-selected);
    }
`;

export const StyledDetailsSelectionMenuItem = styled(MenuItem)`
    font-size: var(--size-14);
    line-height: 21px;
    color: var(--color-grey-800);
    text-transform: uppercase;
    &.selected.selected {
        color: var(--color-secondary);
        background-color: var(--color-secondary-light);
    }
`;

export const StyledDetailsSelectionInput = styled(Select)`
    min-height: 40px;
    padding: 0 8px;
    font-size: var(--size-14);
    line-height: 21px;
    color: var(--color-secondary);
    text-transform: uppercase;
    background: var(--color-secondary-light);
    border-radius: 6px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);

    &::before {
        content: none;
    }
    &::after {
        content: none;
    }
    svg {
        path {
            fill: var(--color-secondary);
        }
    }

    .select {
        background-color: transparent;
    }
`;

export const StyledDetailsMobileWrapper = styled.div`
    padding: 8px;
    margin-top: 8px;
    background-color: var(--color-secondary-light);
    border-radius: var(--radius-10);
    @media ${breakpoints.xs} {
        margin-top: 16px;
    }
`;
